'use es6';

import styled from 'styled-components';
import UIFilterBar from 'UIComponents/nav/UIFilterBar';
import UIInlineLabel from 'UIComponents/form/UIInlineLabel';
import UISection from 'UIComponents/section/UISection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { device } from '../../constants/StyledComponentConstants';
import useMediaQuery from '../../hooks/useMediaQuery';
import RouterDropdownFilter, { RouterFilterTags, ClearFiltersLink, StyledTagsContainer } from '../TracksPage/RouterDropdownFilter';
import { RouterSearchInput, RouterSelectSingle } from '../../features/filters';
import { FILTER_TYPES } from '../../constants/TopFilterConstants';
import { useLocationWithoutParams, useSearchParam } from '../../hooks/searchParamHooks';

// Override .private-button's "overflow: hidden;"
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RouterSelectSingleStyled = styled(RouterSelectSingle).withConfig({
  displayName: "MyLearningTopFilters__RouterSelectSingleStyled",
  componentId: "sc-11v6n8w-0"
})(["&&{overflow:visible;}margin-right:12px;"]);
const FilterContainer = styled(UISection).withConfig({
  displayName: "MyLearningTopFilters__FilterContainer",
  componentId: "sc-11v6n8w-1"
})(["position:relative;margin-left:-12px;margin-top:-20px !important;margin-bottom:4px !important;"]);
const FilterPositionedSearchInput = styled(RouterSearchInput).withConfig({
  displayName: "MyLearningTopFilters__FilterPositionedSearchInput",
  componentId: "sc-11v6n8w-2"
})(["margin-bottom:10px;"]);
const NoFilterPositionedSearchInput = styled(RouterSearchInput).withConfig({
  displayName: "MyLearningTopFilters__NoFilterPositionedSearchInput",
  componentId: "sc-11v6n8w-3"
})(["margin-top:12px;margin-bottom:20px;"]);
const taggedFilters = [FILTER_TYPES.AWARD_TYPE, FILTER_TYPES.CONTENT_TYPE, 'sortBy'];
const MyLearningTopFilters = () => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const [hasFilters] = useLocationWithoutParams(taggedFilters);
  const [sortFilterType] = useSearchParam('sortBy');
  return isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FilterContainer, {
      children: /*#__PURE__*/_jsxs(StyledTagsContainer, {
        children: [taggedFilters.map(filter => /*#__PURE__*/_jsx(RouterFilterTags, {
          filterType: filter
        }, filter)), /*#__PURE__*/_jsx(RouterFilterTags, {
          filterType: sortFilterType
        }), /*#__PURE__*/_jsx(ClearFiltersLink, {
          filtersToClear: taggedFilters
        })]
      })
    }), hasFilters ? /*#__PURE__*/_jsx(FilterPositionedSearchInput, {
      filterType: FILTER_TYPES.SEARCH
    }) : /*#__PURE__*/_jsx(NoFilterPositionedSearchInput, {
      filterType: FILTER_TYPES.SEARCH
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFilterBar, {
      className: "m-top-0 m-bottom-4",
      endSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(UIInlineLabel, {
          label: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.sortBy.filterTitle"
          }),
          children: /*#__PURE__*/_jsx(RouterSelectSingleStyled, {
            filterType: "sortBy",
            menuWidth: 170
          })
        }), /*#__PURE__*/_jsx(RouterSearchInput, {
          filterType: FILTER_TYPES.SEARCH
        })]
      }),
      startSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.myLearning.filterBy"
        }), /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.AWARD_TYPE
        }), /*#__PURE__*/_jsx(RouterDropdownFilter, {
          filterType: FILTER_TYPES.CONTENT_TYPE
        })]
      })
    }), /*#__PURE__*/_jsxs(StyledTagsContainer, {
      children: [taggedFilters.map(filter => /*#__PURE__*/_jsx(RouterFilterTags, {
        filterType: filter
      }, filter)), /*#__PURE__*/_jsx(ClearFiltersLink, {
        filtersToClear: taggedFilters
      })]
    })]
  });
};
export default MyLearningTopFilters;